import * as React from 'react';
import {CardObject} from "../../../../types.d";
import {useState} from "react";
import {TopicModal} from "../../../partials/modals/TopicModal";
import {Link} from "react-router-dom";

export interface ExplanationThumbProps {
    baseUrl: string;
    card: CardObject;
}

export const ExplanationThumb = (props: ExplanationThumbProps) => {
    const [modalVisible, setModalVisible] = useState<boolean>(false);
    const { card } = props;

    return <div className="card m-2 card-data-preview vocabulary-card-view">
        <div className="card-header">
            <strong>{ card.postTitle }</strong>
        </div>
        <div className="card-body">
            <p dangerouslySetInnerHTML={{ __html: card.explanationRules }} />
        </div>
        <div className="d-flex justify-content-between card-footer">
            <Link to={`${props.baseUrl}/${props.card.id}`} className="btn btn-sm btn-primary">Edit</Link>

            <div>
                <h6 className="mt-1">
                    <a href="" onClick={e => {
                        e.preventDefault();

                        setModalVisible(true);
                    }}>Show Topic</a>
                </h6>
            </div>
        </div>

        <TopicModal card={card} visible={modalVisible} toggle={() => setModalVisible(!modalVisible)}/>
    </div>
};
